import { Observable } from "rxjs";

import st from "lib/utils/index";
import { AccountRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { setCurrentUser } from "modules/auth";

export const INITIALIZE_VIEW = "settings/UserAccountView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/UserAccountView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/UserAccountView/UPDATE_MODEL";
export const VALIDATE = "settings/UserAccountView/VALIDATE";
export const SUBMIT = "settings/UserAccountView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/UserAccountView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/UserAccountView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/UserAccountView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.UserAccountView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model, initialModel } }, errors) => {
    errors.add(`model.full_name`, st.validators.presence(model.full_name));
    errors.add(`model.email`, st.validators.presence(model.email));
    if (initialModel.email !== model.email || model.password) {
      errors.add(`model.current_password`, st.validators.presence(model.current_password));
    }
    model.password_confirmation && errors.add(`model.password`, st.validators.presence(model.password));
    model.password && errors.add(`model.password_confirmation`, st.validators.presence(model.password_confirmation));
    model.password &&
      model.password_confirmation &&
      model.password !== model.password_confirmation &&
      errors.add(`model.password_confirmation`, st.validators.invalid());
  },
  submitModel: ({ form: { initialModel, model } }, store) => {
    return AccountRepository.update({
      full_name: model.full_name,
      email: model.email,
      current_password: model.current_password,
      password: model.password,
      password_confirmation: model.password_confirmation,
      locale: model.locale,
      time_zone_name: model.time_zone_name,
    }).map(({ user, meta: { auth_token } }) => {
      store.dispatch(setCurrentUser({ user, auth_token }));
      return {
        ...user,
        current_password: null,
        password: null,
        password_confirmation: null,
      };
    });
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const user = getState().auth.user;
      return initializeModel({
        ...user,
        current_password: null,
        password: null,
        password_confirmation: null,
      });
    }),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/UserAccountView/index.js